export const TEXT = {
  HEADER: {id: 'home.question.header'},
  TITLE: {id: 'home.question.title'},
  CTA: {id: 'home.question.cta'},
} as const;

export const QUIZ_END_SECTION_ID = 'quiz-end-section';
